import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class VisiteService {
	constructor(private http: HttpClient) { }

	list(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:liste',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	listWithConsultation(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:listwithconsultation',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	get(id: number, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:get',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	set(id: any, consultationid: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:set',
			params: {
				id: id,
				consultationid: consultationid,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setMultipleVisite(options:any = []):Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:setMultipleVisite',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
		
	}

    setManyVisite(options:any = []):Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:setManyVisite',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
		
	}

	getTiers(visite: object, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:getTiers',
			params: {
				visite: visite,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getProfessionnels(visite: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:getProfessionnels',
			params: {
				visite: visite,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getConsultations(id, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:getConsultations',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getVisitesByConsultation(consultationid: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:getVisitesByConsultation',
			params: {
				consultationid: consultationid,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getVisiteEtats(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:getEtats',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getActions(id: string, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:getActions',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getVisitesByDossier(dossierid: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:getVisitesByDossier',
			params: {
				dossierid: dossierid,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	addFormulaireToVisites(visites: any, demandeFormulaire: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:addFormulaireToVisites',
			params: {
				visites: visites,
				demandeFormulaire: demandeFormulaire,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	addFormsToVisite(visiteId: any, forms: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:addFormsToVisite',
			params: {
				visiteId: visiteId,
				forms: forms,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	searchAccompagnants(term: string, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:searchAccompagnants',
			params: {
				term: term,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getVisitesBySuivi(suiviId: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.visite:getVisitesBySuivi',
			params: {
				suiviId: suiviId,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	getVisitesByInstruction(Id: any, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.visite:instruction',
            params: {
                id: Id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

	moveAllFromConsult(options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.visite:moveAllFromConsult',
            params: {
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

	moveVisite(options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.visite:moveVisite',
            params: {
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
	
	setFromInset(id: any, type: string="consultation", inset: any = []): Observable<JSONRpcResponse> {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.visite:setfrominset',
				params: {
					id: id,
					type: type,
					inset: inset,
				},
			})
			return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	getFormulaireDemande(id: any, options: any = []): Observable<JSONRpcResponse> {
				let rpcMethod = new JSONRpc({
					jsonrpc: '2.0',
					method: 'webservice.visite:getFormulaireDemande',
					params: {
						id: id,
						options: options
						
					},
				})
				return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
		}
		
	getCourrierList(id: any, options: any = []): Observable<JSONRpcResponse> {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.visite:courriers',
				params: {
					id: id,
					options: options
					
				},
			})
			return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}	
	
	getDocumentList(id: any, options: any = []): Observable<JSONRpcResponse> {
				let rpcMethod = new JSONRpc({
					jsonrpc: '2.0',
					method: 'webservice.visite:documents',
					params: {
						id: id,
						options: options
						
					},
				})
				return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
		}	
	
	
}